import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'patient_select',
    viewPath: props.viewPath,
  })
  let patient_id = useDataValue({
    context: 'person',
    path: 'patient._id',
    viewPath: props.viewPath,
  })

  return function onClick() {
    return submit({ type: 'setPatient', patient_id })
  }
}
